import ITitles from '../../shared/interfaces/titles.interface';

export const TITLE_CLASS_BRANCH: ITitles = {
    icon: 'bar-gym',
    title: 'Clases',
    description: 'Consulta las clases programadas con reservas y gestiona tus espacios.',
}